import React, { FC } from 'react';
import { isEmpty } from 'lodash';
import { Invite } from '../Invite';
import { InviteListProps } from './props';
import './styles.scss';

export const InviteList: FC<InviteListProps> = ({ invites }) => {
  return (
    <div className="settings-team-invite">
      {!isEmpty(invites)
        ? invites.map(({ _id, invitee, state, fullName, email }, index) => (
            <Invite
              email={invitee?.email || email}
              fullName={invitee?.fullName || fullName || email}
              index={index}
              inviteId={_id}
              state={state}
            />
          ))
        : null}
    </div>
  );
};
